import axios from 'axios'

const state = {
	data: null,
	isLoading: false,
	error: null,
	events: null,
	eventsIsLoading: false,
	eventsError: null,
	additional: null,
	additionalIsLoading: false,
	additionalError: null,
	year: null,
	yearIsLoading: false,
	yearError: null,
}

export const mutationTypes = {
	getInvestorsDataStart: '[investorsData] Get data start',
	getInvestorsDataSuccess: '[investorsData] Get data success',
	getInvestorsDataFailure: '[investorsData] Get data failure',
	getCalendarEventsStart: '[calendarEvents] Get data start',
	getCalendarEventsSuccess: '[calendarEvents] Get data success',
	getCalendarEventsFailure: '[calendarEvents] Get data failure',
	getAdditionalDataStart: '[additionalData] Get data start',
	getAdditionalDataSuccess: '[additionalData] Get data success',
	getAdditionalDataFailure: '[additionalData] Get data failure',
	getYearDataStart: '[yearData] Get data start',
	getYearDataSuccess: '[yearData] Get data success',
	getYearDataFailure: '[yearData] Get data failure',
}

export const investorsDataActionTypes = {
	getInvestorsData: '[investorsData] Get data',
	getCalendarEvents: '[calendarEvents] Get data',
	getAdditionalData: '[additionalData] Get data',
	getYearData: '[yearData] Get data',
}

const mutations = {
	[mutationTypes.getInvestorsDataStart](state) {
		state.isLoading = true
	},
	[mutationTypes.getInvestorsDataSuccess](state, payload) {
		state.isLoading = false
		state.data = payload
	},
	[mutationTypes.getInvestorsDataFailure](state) {
		state.isLoading = false
	},
	[mutationTypes.getCalendarEventsStart](state) {
		state.eventsIsLoading = true
	},
	[mutationTypes.getCalendarEventsSuccess](state, payload) {
		state.eventsIsLoading = false
		state.events = payload
	},
	[mutationTypes.getCalendarEventsFailure](state) {
		state.eventsIsLoading = false
	},
	[mutationTypes.getAdditionalDataStart](state) {
		state.additionalIsLoading = true
	},
	[mutationTypes.getAdditionalDataSuccess](state, payload) {
		state.additionalIsLoading = false
		state.additional = payload
	},
	[mutationTypes.getAdditionalDataFailure](state) {
		state.additionalIsLoading = false
	},
	[mutationTypes.getYearDataStart](state) {
		state.yearIsLoading = true
	},
	[mutationTypes.getYearDataSuccess](state, payload) {
		state.yearIsLoading = false
		state.year = payload
	},
	[mutationTypes.getYearDataFailure](state) {
		state.yearIsLoading = false
	},
}

const actions = {
	[investorsDataActionTypes.getInvestorsData](context, { apiUrl, filter }) {
		let url = apiUrl
		if (filter) {
			url += filter
		}

		return new Promise(resolve => {
			context.commit(mutationTypes.getInvestorsDataStart)
			axios
				.get(url)
				.then(response => {
					context.commit(mutationTypes.getInvestorsDataSuccess, response.data)
					resolve(response.data)
				})
				.catch(() => {
					context.commit(mutationTypes.getInvestorsDataFailure)
				})
		})
	},
	[investorsDataActionTypes.getCalendarEvents](context, { apiUrl }) {
		return new Promise(resolve => {
			context.commit(mutationTypes.getCalendarEventsStart)
			axios
				.get(apiUrl)
				.then(response => {
					context.commit(mutationTypes.getCalendarEventsSuccess, response.data)
					resolve(response.data)
				})
				.catch(() => {
					context.commit(mutationTypes.getCalendarEventsFailure)
				})
		})
	},
	[investorsDataActionTypes.getAdditionalData](context, { apiUrl }) {
		return new Promise(resolve => {
			context.commit(mutationTypes.getAdditionalDataStart)
			axios
				.get(apiUrl)
				.then(response => {
					context.commit(mutationTypes.getAdditionalDataSuccess, response.data)
					resolve(response.data)
				})
				.catch(() => {
					context.commit(mutationTypes.getAdditionalDataFailure)
				})
		})
	},
	[investorsDataActionTypes.getYearData](context, { apiUrl }) {
		return new Promise(resolve => {
			context.commit(mutationTypes.getYearDataStart)
			axios
				.get(apiUrl)
				.then(response => {
					context.commit(mutationTypes.getYearDataSuccess, response.data)
					resolve(response.data)
				})
				.catch(() => {
					context.commit(mutationTypes.getYearDataFailure)
				})
		})
	},
}

export default {
	state,
	actions,
	mutations,
}
